import okpData from '../../OKP.json';

export const formatDate = (dateStr) => {
    if (typeof dateStr === 'string') {
        return dateStr.replace(' ', 'T');
    }
    return dateStr;
};

/**
 * Преобразует массив [year, month, day, hour, min, sec?] в ISO-строку.
 */
export const arrayToDate = (arr) => {
    if (!Array.isArray(arr) || arr.length < 3) return null;
    const [year, month, day, hour = 0, minute = 0, second = 0] = arr;
    return new Date(year, month - 1, day, hour, minute, second).toISOString();
};

export const formatOperationStatus = (status) => {
    const statusNumber = Number(status);
    switch (statusNumber) {
        case 1: return 'rgb(50, 205, 50)';
        case 2: return 'rgb(128, 128, 128)';
        case 3: return 'rgb(255, 165, 0)';
        case 4: return 'rgb(255, 0, 0)';
        case 5: return 'rgb(255, 255, 0)';
        case 6: return 'rgb(0, 0, 255)';
        case 7: return 'rgb(128, 0, 128)';
        default: return 'rgb(128, 128, 128)';
    }
};

/**
 * Достаёт первое число из строки ОКП:
 *   "12920: Контроллер"           → "12920"
 *   "381100: Станки токарной..."  → "381100"
 *   "OKP20"                       → "20"
 *   "ОКП10: Токарные станки"      → "10"
 *   ""                            → null
 */
export const getFirstNumberFromOKP = (okp) => {
    if (!okp || typeof okp !== 'string') return null;
    const match = okp.match(/(\d+)/);
    return match ? match[1] : null;
};

/**
 * Эвристика по имени ресурса — если ОКП пуст или не найден.
 */
const guessTypeByName = (name) => {
    if (!name) return 'equipment';
    const lower = name.toLowerCase();

    // ФИО: три слова из русских букв
    if (/^[а-яё]+\s+[а-яё]+\s+[а-яё]+$/i.test(name.trim())) {
        return 'personnel';
    }
    if (
        lower.includes('станок') ||
        lower.includes('пресс') ||
        lower.includes('гильотин') ||
        lower.includes('ножниц') ||
        lower.includes('центр') ||
        lower.includes('линия')
    ) {
        return 'equipment';
    }
    if (
        lower.includes('инструмент') ||
        lower.includes('резец') ||
        lower.includes('комплекс') ||
        lower.includes('стенд')
    ) {
        return 'tool';
    }
    return 'equipment';
};

/**
 * Определяет тип агента по ОКП, agentId и имени.
 */
export const getTypeAgentByOKP = (okp, agentId, nameAgent = '') => {
    // Жёстко зашитые ID
    if (agentId === 'agent.42' || agentId === 'agent.40' || agentId === 'agent.48') {
        return 'personnel';
    }

    if (!okp || okp.trim() === '') {
        return guessTypeByName(nameAgent);
    }

    const firstNumber = getFirstNumberFromOKP(okp);
    if (!firstNumber) {
        return guessTypeByName(nameAgent);
    }

    for (const type in okpData) {
        if (okpData[type].some(item => String(item.OKP) === String(firstNumber))) {
            return type;
        }
    }

    return guessTypeByName(nameAgent);
};